import { render, staticRenderFns } from "./news_table.vue?vue&type=template&id=35b0c2c1&scoped=true"
import script from "./news_table.vue?vue&type=script&lang=ts"
export * from "./news_table.vue?vue&type=script&lang=ts"
import style0 from "./news_table.vue?vue&type=style&index=0&id=35b0c2c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0c2c1",
  null
  
)

export default component.exports